import styled from 'styled-components';

export const NoticeStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.level3};
  flex: 0 0 auto;

  &:empty {
    display: none;
  }
`;

export const Problems = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  padding: ${({ theme }) => `${theme.spacing.level3} ${theme.spacing.level4}`};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background: ${({ theme }) => theme.colors.errorContainer};
  color: ${({ theme }) => theme.colors.onErrorContainer};
`;

export const ProblemList = styled.ul`
  flex: 1 1 240px;
  margin: 0;
  padding-left: ${({ theme }) => theme.spacing.level5};
  ${({ theme }) => theme.font.bodyMedium};
`;
